import Vue from 'vue'
import store from '@/store'
import router from '@/router'
import vuetify from '@/plugins/vuetify'
import app from '@/components/app/app.vue'
import i18n from '@/i18n'
import '@/styles/main.scss'

/* eslint-disable no-new */
new Vue({
  store,
  router,
  vuetify,
  i18n,
  render: h => h(app)
}).$mount('#app')

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js')
}
